import _ from 'lodash';
import { fetchGet, fetchPost } from '~utilities/fetch';
import AbaTypeEnum from './AbaTypeEnum';

export async function abasAddRequest(abaType: AbaTypeEnum, warehouseLoanTransactionUuids: string[]): Promise<Response> {
    return fetchPost('/warehouse-loan-transaction-abas', {
        abaType,
        warehouseLoanTransactionUuids,
    });
}

export async function abasListRequest(abaTypes: AbaTypeEnum[]): Promise<Response> {
    return fetchGet('/warehouse-loan-transaction-abas', {
        abaTypes,
    });
}

export async function abaGetRequest(uuid: string): Promise<Response> {
    return fetchGet(`/warehouse-loan-transaction-abas/${uuid}`);
}

export async function abaHistoriesListRequest(uuid: string): Promise<Response> {
    return fetchGet(`/warehouse-loan-transaction-abas/${uuid}/histories`);
}

export async function abaTransactionsListRequest(uuid: string): Promise<Response> {
    return fetchGet(`/warehouse-loan-transaction-abas/${uuid}/transactions`);
}

export async function unallocatedTransactionsListRequest(abaType: AbaTypeEnum): Promise<Response> {
    return fetchGet('/warehouse-loan-transaction-abas/unallocated-transactions', {
        abaType,
    });
}
